/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { useEffect} from 'react';
import * as breakpoint from '../../styles/breakpoints.module.scss';
import { getImage, withArtDirection } from "gatsby-plugin-image"
import { useLocalization } from "gatsby-theme-i18n";
import PageHeadline from '../../components/PageHeadline';
import Seo from "../../components/SEO"
import { graphql } from 'gatsby';
import AnimatedSection from '../../components/AnimatedSection';
import CommonSection from "../../components/CommonSection";
import IntroductionSection from "../../sections/frame-sticker/IntroductionSection"
import CampaignSection from "../../sections/frame-sticker/CampaignSection";
import InstructionSection from "../../sections/frame-sticker/InstructionSection";
import MoreActivitySection from "../../sections/common/MoreActivitySection";

import CrosssiteBannerSection from '../../sections/common/CrosssiteBannerSection';
import SectionHeadline from '../../components/SectionHeadline'


const FrameSticker = ({ data }) => {
  const { t, addString, localeKey } = useLocalization();

  useEffect(() => {
    addString('frame_sticker',data.allActivitiesFrameStickerCsv.nodes);
  },[addString,data]);


  return (<div>
    <Seo 
        title={data.pageTitle[localeKey]} 
        description={data.pageDescription[localeKey]}  />  
    <PageHeadline category={t('frame_sticker.page.category.label')} title={t('frame_sticker.page.display.title')} bgImg={
      withArtDirection(getImage(data.headlineBg), [
        {
          media: `(min-width: ${breakpoint.mdMin})`,
          image: getImage(data.headlineBg),
        },
        {
          media: `(max-width: ${breakpoint.smMax}) and (min-width: ${breakpoint.smMin})`,
          image: getImage(data.headlineBg_tablet),
        },
        {
          media: `(max-width: ${breakpoint.xsMax})`,
          image: getImage(data.headlineBg_mobile),
        }
      ])}/>

      <IntroductionSection />
      <CampaignSection />

      <CommonSection css={css`
        > div {display:block;}

        @media only screen and (max-width: ${breakpoint.smMax}){
          .sectionHeadline{
            .title{
              font-size: 28px;
              line-height: 36px;
            }
          }
        }
        @media only screen and (max-width: ${breakpoint.xsMax}){
          .sectionHeadline{
            .title{
              font-size: 20px;
              line-height: 28px;
            }
          }
        }
      `}>
        <AnimatedSection>
          <SectionHeadline title={t('frame_sticker.usage.title')} category={t('frame_sticker.usage.subtitle')}/>
        </AnimatedSection>
        <InstructionSection 
          title={t('frame_sticker.usage.frame.title')}
          desc={t('frame_sticker.usage.frame.text')}
          annotation={t('frame_sticker.usage.frame.annotation')}
          button={{
            href : t('frame_sticker.usage.frame.ui_guide.button.url'),
            label : t('frame_sticker.usage.frame.ui_guide.button.label')
          }}
          image={[{
            image: getImage(data[`guide_frame_${localeKey}`]),
            alt: 'Frame 1'
          }]}

          direction={'left'}
        />
        <InstructionSection 
          title={t('frame_sticker.usage.sticker.title')}
          desc={t('frame_sticker.usage.sticker.text')}
          annotation={t('frame_sticker.usage.sticker.annotation')}
          button={{
            href : t('frame_sticker.usage.sticker.ui_guide.button.url'),
            label : t('frame_sticker.usage.sticker.ui_guide.button.label')
          }}
          image={[{
            image: getImage(data[`guide_sticker_1_${localeKey}`]),
            alt: 'Sticker 1'
          },{
            image: getImage(data[`guide_sticker_2_${localeKey}`]),
            alt: 'Sticker 2'
          }]}
          direction={'right'}
        />
      </CommonSection>

      <MoreActivitySection currentPage={"frame_sticker"}/>
      <CrosssiteBannerSection />
  </div>);
}
 
export default FrameSticker;

export const query = graphql`
  query ActivityFrameStickerPageQuery {
    pageTitle : activitiesFrameStickerCsv(key: {regex: "/^page.title/"}) {
      ...localizedContent
    }
    pageDescription :activitiesFrameStickerCsv(key: {regex: "/^page.description/"}) {
      ...localizedContent
    }

    allActivitiesFrameStickerCsv {
      nodes {
        ...localizedContent
      }
    }
    allActivityCsv {
      nodes {
        ...localizedContent
      }
    }

    headlineBg : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/bg_pageHeader.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    headlineBg_tablet : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/bg_pageHeader_tablet.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    headlineBg_mobile : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/bg_pageHeader_mobile.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }

    gpose_1 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_1.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    gpose_2 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_2.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    gpose_3 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_3.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    gpose_4 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_4.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    gpose_5 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_5.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    gpose_6 : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/gpose_6.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }

    guide_frame_ja : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_frame_ja.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_frame_en_US : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_frame_en_US.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_frame_en_GB : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_frame_en_GB.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_frame_fr : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_frame_fr.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_frame_de : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_frame_de.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }

    guide_sticker_1_ja : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_sticker_1_ja.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_sticker_1_en_US : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_sticker_1_en_US.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_sticker_1_en_GB : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_sticker_1_en_GB.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_sticker_1_fr : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_sticker_1_fr.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_sticker_1_de : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_sticker_1_de.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }

    guide_sticker_2_ja : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_sticker_2_ja.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_sticker_2_en_US : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_sticker_2_en_US.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_sticker_2_en_GB : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_sticker_2_en_GB.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_sticker_2_fr : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_sticker_2_fr.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    guide_sticker_2_de : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/activity/FrameSticker/guide_sticker_2_de.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }

    activitiesList : allActivities(
      sort: {fields: order},
      filter: {
        data: {
          status: {eq: "publish"}
        }
      }) {
      edges {
        node {
          title {
            ...localizedContent
          }
          desc {
            ...localizedContent
          }
          outbound_url {
            ...localizedContent
          }
          inbound_url
          thumb {
            childImageSharp {
              gatsbyImageData(
                layout: FULL_WIDTH
                placeholder: NONE
              )
            }
          }
          data{
            ...localizedContent
            order
            update_date
            status
            key
          }
        }
      }
    }
    
    
  }
`
